import React, {useEffect} from "react";

function Alert(props) {

    const [show, setShow] = React.useState(false);
    const [alertType, setAlertType] = React.useState(props.type);


    useEffect(() => {
        const timerId = setTimeout(() => {
            setShow(false);

            setTimeout(() => {
                setAlertType(null);
                if (props.onHide) {props.onHide();}
            }, 250);
        }, 3000);
    }, [show]);


    useEffect(() => {
        setAlertType(props.type);
        setShow(true);
    }, [props.type, props.text]);


    useEffect(() => {
        setTimeout(() => {
            setShow(true);
        }, 50);
    }, []);


    return alertType && (
        <div className={'alert alert-'+alertType+' fade'+(show ? ' show' : '')} role="alert">
            {props.text}
        </div>
    );
}

export default Alert;